<wbo-edit-page #editPage [title]="model.data.name" [formGroup]="editPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <ng-container>
                    <wbo-edit-grid [data]="model.data.sellableSizes" [editable]="true"
                                   [removable]="true" [entityPath]="'sellableSizes'">
                        <wbo-text-column field="label" [editable]="true"></wbo-text-column>
                        <wbo-text-column field="abbreviation" [editable]="true"></wbo-text-column>
                        <wbo-edit-grid-add-row >
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </ng-container>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
